import React, { useEffect, useState, useCallback } from 'react';
import { connect } from "react-redux";
import notify from 'devextreme/ui/notify';
import data from "../assets/apiRoutes.json";
import axios from "axios";
import { LoadPanel } from 'devextreme-react/load-panel';
import AccordionReact from 'devextreme-react/accordion';
import TextBox from 'devextreme-react/text-box';
import DateBox from 'devextreme-react/date-box';
import { Button } from 'devextreme-react/button';

import Toolbar, { Item } from "devextreme-react/toolbar";
import {
  Column,
  DataGrid,
  GroupPanel,
  Scrolling,
  Grouping,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Sorting,
  Paging,
  Export,
  Pager,
  ColumnChooser,
  ColumnChooserSearch,
  StateStoring,
  Summary,
  TotalItem,
} from "devextreme-react/data-grid";
import Validator from 'devextreme-react/validator';
import ValidationSummary from 'devextreme-react/validation-summary';
import { RequiredRule } from 'devextreme-react/form';
const searchpanel = [
  {
    ID: 1,
    Title: 'Search Filters'
  }
];
const ViewDashboard = (props) => {
  const [numericColumns, setNumericColumns] = useState([]);
  const [loadPanelVisible, setLoadPanelVisible] = useState(false);
  const [showIndicator, setShowIndicator] = useState(true);
  const [shading, setShading] = useState(true);
  const [showPane, setShowPane] = useState(true);
  const [hideOnOutsideClick, setHideOnOutsideClick] = useState(false);
  const hideLoadPanel = useCallback(() => {
    setLoadPanelVisible(false);
  }, [setLoadPanelVisible]);
  const [selectedItems, setSelectedItems] = useState([searchpanel[0]]);
  const [dashboardId, setDashboardId] = useState('');
  const [parameters, setParameters] = useState([]);
  const [formData, setFormData] = useState({});
  var accessToken = props.oidc.user.access_token;
  const [dataSource, setDataSource] = useState([]);
  const position = { of: '#accordion-containe2' };
  const [searchPanelStatus, setSearchPanelStatus] = useState(true);
  const selectionChanged = useCallback(
    (e, tg) => {
      let newItems = [...selectedItems];
      e.removedItems.forEach((item) => {
        const index = newItems.indexOf(item);
        if (index >= 0) {
          newItems.splice(index, 1);
        }
      });
      if (e.addedItems.length) {
        newItems = [...newItems, ...e.addedItems];
      }
      setSelectedItems(newItems);
      setSearchPanelStatus((prevStatus) => {
        const newStatus = !prevStatus;
        return newStatus;
      });
    },
    [selectedItems, setSelectedItems],
  );
  const urlPathName = window.location.pathname;
  const urldecodedPathname = decodeURIComponent(urlPathName);
  const urlPathParts = urldecodedPathname.split('/');
  const pageUrl = urlPathParts[urlPathParts.length - 1];
  if (dashboardId != pageUrl) {
    setDashboardId(pageUrl);
  }
  const handleChangeDate = (e, parameterName) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      [parameterName]: e
    }))
  };
  const handleChange = (e, parameterName) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      [parameterName]: e.value
    }))
  };
  const isEmptyValueExist = () => {
    for (const [key, value] of Object.entries(formData)) {
      if (!value) {
        return true;
      }
    }
    return false;
  };
  const handleSubmit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    setLoadPanelVisible(true);
    let request = {
      DashboardName: dashboardId,
      Parameters: formData,
    };
    try {
      const response = await axios.post(
        `${window._env_.REACT_APP_APIS}/${data.DBL.SearchDashboardByParameters}`,
        request,
        {
          headers: {
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
          }
        }
      );
      const responseData = response.data;
      if (responseData.success) {
        const parsedData = JSON.parse(responseData.data);
        if (parsedData && parsedData.length > 0) {
          const firstRow = parsedData[0];
          const numericCols = Object.keys(firstRow).filter(
            key => !isNaN(firstRow[key])
          );
          setNumericColumns(numericCols);
        }
        setDataSource(parsedData);
      } else {
        notify(
          {
            message: responseData.message,
            width: 100,
          },
          'error',
          3000,
        );
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    } finally {
      setTimeout(hideLoadPanel, 1000);
    }
  };
  const GetDashboardParameters = async (id) => {
    setLoadPanelVisible(true);
    try {
      const response = await axios.get(`${window._env_.REACT_APP_APIS}/${data.DBL.GetDashboardParameters}?id=${id}`, {
        headers: {
          access_token: accessToken,
          Authorization: `Bearer ${accessToken}`
        }
      });
      const responseData = response.data;
      if (responseData.success) {
        setDataSource(responseData.data.gridColumns);
        setParameters(responseData.data.queryParameters);
      } else {
        notify(
          {
            message: responseData.message,
            width: 100,
          },
          'error',
          3000,
        );
      }
    } catch (error) {
      notify(
        {
          message: 'Error: Something went wrong try again',
          width: 100,
        },
        'error',
        3000,
      );
    } finally {
      setTimeout(hideLoadPanel, 1000);
    }
  };
  const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
  const renderField = (param) => {
    return (
      <div className="col-md-3 mb-3" key={param.parameterName}>
        {param.type === 'date' ? (
          <DateBox
            value={formData[param.parameterName]}
            className="light-ui-textbox"
            labelMode="static"
            label={param.parameterName + (param.isrequired ? " *" : "")}
            defaultValue=""
            style={{ width: '100%' }}
            onValueChange={(e) => handleChangeDate(e, param.parameterName)}
          >
            {
              param.isrequired && <Validator>
                <RequiredRule message={param.parameterName + " is required."}></RequiredRule>
              </Validator>
            }
          </DateBox>
        ) : (
          <TextBox
            value={formData[param.parameterName]}
            className="light-ui-textbox"
            labelMode="static"
            label={param.parameterName + (param.isrequired ? " *" : "")}
            valueChangeEvent="keyup"
            defaultValue=""
            style={{ width: '100%' }}
            onValueChanged={(e) => handleChange(e, param.parameterName)}
          >
            {
              param.isrequired && <Validator>
                <RequiredRule message={param.parameterName + " is required."}></RequiredRule>
              </Validator>
            }
          </TextBox>
        )}
      </div>
    );
  };
  const renderRows = () => {
    const rows = [];
    for (let i = 0; i < parameters.length; i += 4) {
      rows.push(
        <div className="row" style={{ paddingTop: "10px" }} key={i}>
          {parameters.slice(i, i + 4).map((param) => renderField(param))}
        </div>
      );
    }
    return rows;
  };
  useEffect(() => {
    const pathname = window.location.pathname;
    const decodedPathname = decodeURIComponent(pathname);
    const pathParts = decodedPathname.split('/');
    const dashboardIdFromUrl = pathParts[pathParts.length - 1];
    setDashboardId(dashboardIdFromUrl);
    GetDashboardParameters(dashboardIdFromUrl);
  }, [dashboardId]);
  return (
    <div>
      <div className="row" style={{ marginLeft: "2px" }}>
        <div className="col-md-12" style={{ paddingLeft: "0px", paddingRight: "0px" }}>
          <div id="accordion" >
            <LoadPanel
              shadingColor="rgba(0,0,0,0.4)"
              position={position}
              onHiding={hideLoadPanel}
              visible={loadPanelVisible}
              showIndicator={showIndicator}
              shading={shading}
              showPane={showPane}
              hideOnOutsideClick={hideOnOutsideClick}
            />
            <AccordionReact
              dataSource={searchpanel}
              collapsible={true}
              multiple={false}
              animationDuration={300}
              selectedItems={selectedItems}
              onSelectionChanged={e => {
                if (e.currentTarget === e.target) {
                  selectionChanged(e, e.target);
                }
              }}
              itemTitleRender={() => (
                <Toolbar className="accordian-toolbar">
                  <Item location="before">
                    <div className="title">
                      <h6
                        style={{
                          color: window._env_.Color2
                        }}
                      >
                        Enter Your Query For {dashboardId}
                      </h6>
                    </div>
                  </Item>
                  <Item location="after">
                    <Button className="accordianButton"  useSubmitBehavior={true} onClick={handleSubmit} text="Search" type="default" />
                  </Item>

                </Toolbar>

              )}

              itemRender={(itemProps) => (
                <div style={{ height: '131px', overflowY: 'auto', marginTop: '-10px' }}>
                  <form onSubmit={handleSubmit}>
                    {/* <div className="row">
                      <div className="col-md-12 text-right">
                        <Button
                          text="Search"
                          type="default"
                          useSubmitBehavior={true}
                          stylingMode="contained">
                        </Button>
                      </div>
                    </div> */}
                    {renderRows()}
                    <div className="row">
                      <ValidationSummary className="pl-3 pt-1" id="summary" />
                    </div>
                  </form>
                </div>
              )}
              id="accordion-container"
            />
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
              dataSource={dataSource}
              allowColumnReordering={true}
              allowColumnResizing={true}
              showBorders={true}
              hoverStateEnabled={true}
              className={searchPanelStatus ? "ViewDashboardGidStyleOpenPanel" : "ViewDashboardGidStyleClosePanel"}
              searchExpr="status"
              searchEnabled={true}
              columnAutoWidth={true}
              scrolling={{ mode: "standard" }}
            >
              <ColumnChooser
                enabled={true}
                title="Choose Column"
                width={290}
                height={290}
                sortOrder="asc"
              >
                <ColumnChooserSearch
                  enabled={true}
                  editorOptions={{ placeholder: 'Search column' }} />
              </ColumnChooser>
              <Export enabled={true} allowExportSelectedData={true} />
              <Sorting visible={true} mode="multiple" />
              <Paging defaultPageSize={10} />
              <Pager
                visible={true}
                showPageSizeSelector={true}
                allowedPageSizes={allowedPageSizes}
                showNavigationButtons={true}
              />
              <FilterRow visible={true} />
              <FilterPanel visible={true} />
              <HeaderFilter enabled={false} visible={false} />
              <GroupPanel visible={false} />
              <Grouping autoExpandAll={false} />
              <StateStoring
                enabled={true}
                type="custom"
              />
              <Scrolling rowRenderingMode="virtual" />
              <FilterRow visible={true} />
              <Scrolling mode="virtual" />
              <Summary>
                {numericColumns.map(column => (
                  <TotalItem
                    key={column}
                    column={column}
                    summaryType="sum"
                    displayFormat="Total: {0}"
                  />
                ))}
              </Summary>
            </DataGrid>
          </div>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(ViewDashboard);
